import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NewGroupInfos} from "../../../../../lib/models/group.model";
import {group} from "@angular/animations";
import {ToolsService} from "../../../../../lib/services/tools.service";

@Component({
  selector: 'ms-db-creation-dialog',
  templateUrl: './group-creation-dialog.component.html',
  styleUrls: ['./group-creation-dialog.component.scss'],
  standalone: false
})
export class GroupCreationDialogComponent implements OnInit {

  public newGroupInfos: NewGroupInfos = {
    groupId: "",
    mainUserEmail: "",
    mainUserLastName: "",
    mainUserNihii: "",
    mainUserFirstName: "",
    mainUserInss: ""
  }

  constructor(
    private toolsService: ToolsService,
    public dialogRef: MatDialogRef<GroupCreationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedConfig: any,
  ) {
  }

  ngOnInit() {
    this.refreshNewGroupInfos();
  }

  private refreshNewGroupInfos() {
    this.newGroupInfos = {
      groupId: "",
      mainUserEmail: "",
      mainUserFirstName: "",
      mainUserLastName: "",
      mainUserNihii: "",
      mainUserInss: ""
    }
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public async createGroup() {
    if (this.newGroupInfos?.groupId && this.newGroupInfos?.mainUserEmail && this.newGroupInfos?.mainUserFirstName && this.newGroupInfos?.mainUserLastName) {
      const creation = await this.toolsService.launchGroupCreation(this.newGroupInfos)
      this.refreshNewGroupInfos();
      this.dialogRef.close(creation);
    }
  }

  protected readonly group = group;
}
